var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "BlBackdrop",
        {
          attrs: {
            title: "Archive item",
            label: "Archive item",
            submitLoading: _vm.submitLoading
          },
          on: {
            "backdrop-close": function($event) {
              return _vm.$emit("close-modal")
            },
            "backdrop-action": _vm.onSubmit
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "px-8 flex flex-col gap-2 overflow-y-auto",
              style: { width: "40rem", maxHeight: "calc(100vh - 16rem)" }
            },
            [
              _c(
                "div",
                [
                  _c("BlTextBody2", {
                    attrs: { text: "You are about to archive" }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    staticClass: "font-bold",
                    attrs: { text: _vm.creditPackageItem.name + "." }
                  }),
                  _vm._v(" "),
                  _vm.creditPackageItem.packages.length
                    ? _c("BlTextBody2", {
                        attrs: { text: "This action will affect" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.creditPackageItem.packages.length
                    ? _c("BlTextBody2", {
                        staticClass: "font-bold",
                        attrs: { text: _vm.creditPackageItem.packages.length }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.creditPackageItem.packages.length
                    ? _c("BlTextBody2", { attrs: { text: "package(s):" } })
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _vm.creditPackageItem.packages.length
                ? _c(
                    "div",
                    _vm._l(_vm.creditPackageItem.packages, function(
                      creditPackage
                    ) {
                      return _c(
                        "div",
                        {
                          key: creditPackage.id,
                          staticClass: "px-2 flex items-center gap-2"
                        },
                        [
                          _c("div", {
                            staticClass:
                              "h-1 w-1 flex-shrink-0 bg-slate-800 rounded"
                          }),
                          _vm._v(" "),
                          _c("BlTextBody2", {
                            staticClass: "font-bold",
                            attrs: { text: creditPackage.name }
                          })
                        ],
                        1
                      )
                    }),
                    0
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.creditPackageItem.packages.length
                ? _c(
                    "div",
                    [
                      _c("BlTextBody2", {
                        attrs: {
                          text:
                            "Archiving this item will make it unavailable for new credit transaction."
                        }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        attrs: {
                          text:
                            "However, it will remain linked to any existing appointments or credits."
                        }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        attrs: { text: "Are you sure you want to proceed?" }
                      })
                    ],
                    1
                  )
                : _c(
                    "div",
                    [
                      _c("BlTextBody2", {
                        attrs: {
                          text:
                            "Archiving this item will make it unavailable for new credit transactions and remove it from the affected packages, which will alter the total price and total credits in those packages."
                        }
                      }),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        attrs: {
                          text:
                            "However, existing transactions that include this item will remain unaffected."
                        }
                      })
                    ],
                    1
                  )
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-410d9136", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-410d9136","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/center/packageItem/ArchivePackageItemModal.vue
// module id = null
// module chunks = 